import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { radius, themeMode, palette, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var avatarSizes = variant({
  prop: "size",
  variants: {
    xxs: {
      height: "16px",
      width: "16px"
    },
    xs: {
      height: "24px",
      width: "24px"
    },
    sm: {
      height: "36px",
      width: "36px"
    },
    md: {
      height: "48px",
      width: "48px"
    },
    lg: {
      height: "64px",
      width: "64px"
    },
    xl: {
      height: "80px",
      width: "80px"
    },
    xxl: {
      height: "112px",
      width: "112px"
    },
    jb: {
      height: "176px",
      width: "176px"
    },
    mg: {
      height: "240px",
      width: "240px"
    }
  }
});
var Avatar = styled(Box).withConfig({
  componentId: "ysxnzn-0"
})(["display:flex;justify-content:center;align-items:center;aspect-ratio:1/1;border-radius:", ";img{object-fit:cover;height:100%;width:100%;border-radius:", ";}", ";", ""], function (_ref) {
  var isRound = _ref.isRound;
  return radius(isRound ? "round" : "sm");
}, function (_ref2) {
  var isRound = _ref2.isRound;
  return radius(isRound ? "round" : "sm");
}, themeMode({
  dark: css(["background-color:", ";color:", ";"], palette("neutral.700"), palette("neutral.50")),
  light: css(["background-color:", ";color:", ";"], palette("neutral.300"), palette("neutral.900"))
}), avatarSizes);
export { Avatar };